import kr from '../kr/kr';
import Swiper from 'swiper/bundle'

export default class SliderOpions extends kr.Component {
    init() {
        this.slideOpionsTexts();
    }
    slideOpionsTexts() {
        const swiper = new Swiper('.swiper-opinions', {
            // loop: true,
            // loopFillGroupWithBlank: true,
            resizeObserver: true,
            freeMode: true,
            freeModeSticky: true,
            loop: true,
            loopFillGroupWithBlank: true,
            slidesPerView: 1,
            spaceBetween: 0,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                },
                1024: {
                    slidesPerView: 2,
                    spaceBetween: 40
                },
                1366: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                }
            }
        });
    }
}

kr.registerComponent('.swiper-opinions', {
    component: SliderOpions
});